import { type Customer } from '@hungryroot/customer';
import { FoodProfileDisclosure } from '@hungryroot/page-food-profile';
import { useTagGroup } from '@hungryroot/rest-hooks';
import { tagGroups, useCustomerTagGroup } from '@hungryroot/tags';
import { Paragraph, Heading, Cuisines } from '@hungryroot/ui-kit';
import { getCustomerTags } from '../../utils/getCustomerTags';
import { ControlTagBinary } from '../ControlTagBinary/ControlTagBinary';
import styles from './CuisinesSection.module.css';

interface Props {
  testid?: string;
  customerId: Customer['id'];
}

export function CuisinesSection(props: Props) {
  const { testid, customerId } = props;
  const { data: customerTagGroupData } = useCustomerTagGroup(tagGroups.cuisine);

  // Fetches tags from API so we can compare them to the customer's preferences when rendering `subtitle`
  const tagGroup = useTagGroup(tagGroups.cuisine);
  const { data: tagGroupData } = tagGroup || {};
  const queryTags = tagGroupData?.tags;

  const subtitle = getCustomerTags(customerTagGroupData, queryTags);

  return (
    <section data-testid={testid} className={styles.container}>
      <FoodProfileDisclosure
        testid={`${testid}-disclosure`}
        title="Cuisines"
        subtitle={subtitle || 'Set your preferences.'}
        icon={<Cuisines />}
        deepLink="cuisine-preferences"
      >
        <Heading variant="H5">What cuisines do you like?</Heading>
        <Paragraph className={styles.text}>
          We'll use your preferences to suggest recipes that suit your tastes.
        </Paragraph>
        <ControlTagBinary
          testid={`${testid}-control`}
          customerId={customerId}
          tagGroupId={tagGroups.cuisine}
        />
      </FoodProfileDisclosure>
    </section>
  );
}
